function parseAndMultiply(numberString, multiplier) {
  // Handle ranges, considering "-", "–", and "—"
  const rangeMatch = numberString.match(/^([\d.]+)[-\u2013\u2014]([\d.]+)$/); // Matches numbers separated by any dash variant
  if (rangeMatch) {
    const [_, min, max] = rangeMatch;
    return `${min * multiplier}–${max * multiplier}`;
  }

  // Handle simple numbers
  return numberString * multiplier;
}

export default function multiplyIngredients(ingredients, servings, baseServingSize) {
  // multiply the ingredient "number" based on selected "servings"
  const multiplier = servings / baseServingSize;

  const multipliedIngredients = ingredients.map((ingredientList) => {
    const updatedItems = ingredientList.items.map((item) => {
      
      let multipliedNumber = item.number;
      if (typeof multipliedNumber === 'string') {
        multipliedNumber = parseAndMultiply(multipliedNumber, multiplier);
      } else if (typeof multipliedNumber === 'number') {
        multipliedNumber *= multiplier;
      }

      let multipliedNumberMetric = item.numberMetric;
      if (typeof multipliedNumberMetric === 'string') {
        multipliedNumberMetric = parseAndMultiply(multipliedNumberMetric, multiplier);
      } else if (typeof multipliedNumberMetric === 'number') {
        multipliedNumberMetric *= multiplier;
      }

      return {
        ...item,
        number: multipliedNumber,
        numberMetric: multipliedNumberMetric
      }
    })

    return { ...ingredientList, items: updatedItems };
  })

  return multipliedIngredients;
}